module.exports = __webpack_public_path__ + "img/example-color-enterprise.ceb44cc7.svg";